module.exports = __webpack_public_path__ + "static/media/imgrightside.1ef6b195.webp";